import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
}

const leftMenuBar = (state = initialState, action) => {
  switch (action.type) {
    case types.leftMenuBar.OPEN:
      return { ...state, open: true }
    case types.leftMenuBar.CLOSE:
      return { ...state, open: false }
    default:
      return state
  }
}

export default leftMenuBar



// WEBPACK FOOTER //
// ./src/reducers/Common/MenuAppBar/LeftMenuBar.js